exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row {\n  margin-bottom: 1em; }\n\n.input-group {\n  max-width: 350px; }\n  .input-group input[type='text'] {\n    border-right: white; }\n  .input-group .input-group-text {\n    color: dodgerblue;\n    background-color: white; }\n\n.quota-field {\n  max-width: 100px;\n  margin: 0 auto; }\n\n.btn-primary:disabled {\n  background-color: gray;\n  border-color: gray;\n  cursor: not-allowed; }\n\n.card {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  text-align: center;\n  background-color: #ffffff;\n  height: 100%;\n  max-height: 450px;\n  overflow-y: scroll; }\n  .card .disabled {\n    background-color: #ECECEC;\n    color: darkgrey; }\n  .card .icon-cell {\n    padding-top: 20px; }\n  .card .icon {\n    float: left;\n    padding-top: 10px;\n    color: dodgerblue;\n    font-size: 18px;\n    cursor: pointer; }\n  .card .impersonateIcon {\n    color: dodgerblue;\n    font-size: 22px;\n    float: left;\n    cursor: pointer; }\n  .card .deleteIcon {\n    padding-right: 10px;\n    color: red;\n    font-size: 22px;\n    float: right;\n    cursor: pointer; }\n\nbutton {\n  margin-left: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/shared/user-list/user-list.component.scss
// module id = 1283
// module chunks = 0